import { Component } from '@mycolorway/tao';
import { MDCSelect, MDCSelectHelperText } from '@material/select';

export default Component('tr-select-field', {
  properties: {
    disabled: {
      type: Boolean,
      default: false,
      observer() {
        this.selectField.disabled = this.disabled;
      },
    },
  },

  connected() {
    this.selectField = new MDCSelect(this.querySelector('.mdc-select'));
    this.helperText = new MDCSelectHelperText(this.querySelector('.mdc-select-helper-text'));
    this.addEventListeners();
  },

  addEventListeners() {
    this.selectField.listen('MDCSelect:change', this.handleSelectChanged.bind(this));
  },

  removeEventListeners() {
    this.selectField.unlisten('MDCSelect:change', this.handleSelectChanged.bind(this));
  },

  handleSelectChanged() {
    this.namespacedTrigger('change', {
      detail: this.selectField.value,
      bubbles: true,
    });
  },

  getValue() {
    return this.selectField.value;
  },

  disconnected() {
    this.selectField.destroy();
    this.helperText.destroy();
    this.removeEventListeners();
  },

  layout() {
    this.selectField.layout();
  },

  reset() {
    this.selectField.value = '';
  },
});
